import { SText } from '@/components/atoms';
import SHeading from '@/components/atoms/SHeading';
import { IMG_SNAPBOX_OUTSIDE1, IMG_SNAPBOX_OUTSIDE2, IMG_SNAPBOX_OUTSIDE3, IMG_SNAPBOX_OUTSIDE4 } from '@/constants/imagesUrl';
import Image from 'next/image';
import React from 'react';
import { useTranslation } from "react-i18next";

const ExteriorBoothDesign = () => {
    const { t } = useTranslation();

    const images = [
        { src: IMG_SNAPBOX_OUTSIDE1 },
        { src: IMG_SNAPBOX_OUTSIDE2 },
        { src: IMG_SNAPBOX_OUTSIDE3 },
        { src: IMG_SNAPBOX_OUTSIDE4 },
    ];

    return (
        <div className="px-4 mt-8">
            <SHeading
                text={t("home.exterior_booth_design.title")}
                className="text-center py-2 mt-4"
            />
            <SText
                text={t("home.exterior_booth_design.description")}
                className="text-center text-base max-w-2xl mx-auto mb-4"
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {images.map((image, index) => (
                    <div
                        key={`image-${index}`}
                        className="flex justify-center transform transition-transform duration-300 hover:scale-110"
                    >
                        <Image
                            src={image.src}
                            alt={`Exterior design ${index + 1}`}
                            width={192}
                            height={0}
                            className="object-cover w-full rounded-lg shadow-lg hover:object-contain"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ExteriorBoothDesign;